<template>
  <div class="auth-page auth-page--scroll">
    <div class="auth-wrapper auth-v1">
      <div class="auth-inner auth-inner--wide">
        <v-card class="auth-card pa-6">
          <v-card-title class="d-flex align-center justify-center py-7">
            <router-link
              to="/signin"
              class="d-flex align-center"
            >
              <h2 class="text-2xl font-weight-semibold">
                <span class="primary--text">{{ empresaName }}</span>
              </h2>
            </router-link>
          </v-card-title>

          <v-card-text class="text-center">
            <h2 class="mb-2">POLÍTICA DE PRIVACIDADE — LIGDATA</h2>
            <p><strong>Última atualização:</strong> 25 de maio de 2026</p>
          </v-card-text>

          <v-card-text>
            <p>
              Bem-vindo à Ligdata.<br>
              Esta Política de Privacidade descreve como coletamos, utilizamos, armazenamos e protegemos os dados pessoais tratados por meio da plataforma Ligdata, incluindo seus serviços de SMS, RCS, Voz/URA, WhatsApp, automações e demais funcionalidades disponibilizadas.
            </p>

            <h3 class="mt-4 mb-2">1. SOBRE A PLATAFORMA</h3>
            <p>A Ligdata é uma plataforma CPaaS (Communication Platform as a Service) voltada para comunicação multicanal, permitindo o envio e gerenciamento de campanhas de comunicação por SMS, RCS, WhatsApp, Voz/URA, automação de listas, higienização de números, gerador de números e serviços integrados de comunicação.</p>

            <h3 class="mt-4 mb-2">2. DADOS COLETADOS</h3>
            <p><strong>2.1 Dados cadastrais</strong></p>
            <ul>
              <li>Nome</li>
              <li>Razão social</li>
              <li>CPF ou CNPJ</li>
              <li>Endereço</li>
              <li>E-mail</li>
              <li>Telefone</li>
              <li>Dados de autenticação</li>
            </ul>
            <p class="mt-2"><strong>2.2 Dados financeiros</strong></p>
            <ul>
              <li>Histórico de recargas</li>
              <li>Movimentações de carteira</li>
              <li>Dados de cobrança</li>
              <li>Histórico de pagamentos via PIX</li>
            </ul>
            <p class="mt-2"><strong>2.3 Dados operacionais</strong></p>
            <ul>
              <li>Logs de acesso</li>
              <li>IP</li>
              <li>Navegador e dispositivo</li>
              <li>Histórico de campanhas</li>
              <li>Relatórios de envio e entrega</li>
            </ul>
            <p class="mt-2"><strong>2.4 Dados enviados pelos clientes</strong></p>
            <p>Os usuários da plataforma podem importar bases de contatos, números telefônicos, mensagens, arquivos, áudios e templates destinados às campanhas.</p>

            <h3 class="mt-4 mb-2">3. FINALIDADE DO TRATAMENTO</h3>
            <p>Os dados são utilizados para:</p>
            <ul>
              <li>Prestação dos serviços contratados;</li>
              <li>Processamento e envio de campanhas;</li>
              <li>Autenticação e segurança da conta;</li>
              <li>Validação de saldo e cobrança;</li>
              <li>Emissão de relatórios;</li>
              <li>Prevenção de fraudes;</li>
              <li>Atendimento ao cliente;</li>
              <li>Cumprimento de obrigações legais.</li>
            </ul>

            <h3 class="mt-4 mb-2">4. COMPARTILHAMENTO DE DADOS</h3>
            <p>Os dados poderão ser compartilhados com operadoras de telecomunicação, gateways de SMS/RCS/Voz, provedores de WhatsApp Business, parceiros de infraestrutura, prestadores financeiros e autoridades legais quando exigido.</p>

            <h3 class="mt-4 mb-2">5. RESPONSABILIDADE SOBRE AS BASES DE CONTATO</h3>
            <p>O cliente é integralmente responsável pela origem lícita dos contatos importados e pela obtenção dos consentimentos necessários conforme a LGPD.</p>

            <h3 class="mt-4 mb-2">6. ARMAZENAMENTO E SEGURANÇA</h3>
            <p>A Ligdata adota medidas técnicas e organizacionais de segurança, incluindo controle de acesso, autenticação, logs e monitoramento.</p>

            <h3 class="mt-4 mb-2">7. COOKIES E TECNOLOGIAS</h3>
            <p>A plataforma poderá utilizar cookies, sessões e ferramentas analíticas para melhorar a experiência e garantir segurança.</p>

            <h3 class="mt-4 mb-2">8. RETENÇÃO DE DADOS</h3>
            <p>Os dados poderão ser armazenados pelo período necessário para prestação dos serviços, cumprimento legal e prevenção de fraudes.</p>

            <h3 class="mt-4 mb-2">9. DIREITOS DO TITULAR</h3>
            <p>Nos termos da LGPD, o titular poderá solicitar acesso, correção, exclusão, anonimização, portabilidade e demais direitos previstos em lei.</p>

            <h3 class="mt-4 mb-2">10. USO INDEVIDO</h3>
            <p>É proibida a utilização da plataforma para spam ilegal, fraudes, phishing, conteúdo ilícito ou qualquer prática que viole a legislação.</p>

            <h3 class="mt-4 mb-2">11. ALTERAÇÕES</h3>
            <p>A Ligdata poderá alterar esta Política a qualquer momento mediante publicação da versão atualizada.</p>

            <h3 class="mt-4 mb-2">12. CONTATO</h3>
            <p>Dúvidas relacionadas à privacidade poderão ser encaminhadas pelos canais oficiais da Ligdata.</p>
          </v-card-text>

          <v-card-actions class="d-flex justify-center pb-4">
            <v-btn
              color="primary"
              outlined
              @click="$router.push('/signin')"
            >
              Voltar ao Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    empresaName() {
      return process.env.VUE_APP_EMPRESA_ID == 1 ? 'LigData' : 'BetEnvios'
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
